import type {
  OAuthProviderCredentialsSummary,
  OAuthProviderSlug,
  SmtpSettingsResponse,
  StorageSettingsResponse,
  UpdateOAuthProviderCredentialsRequest,
  UpdateSmtpSettingsRequest,
  UpdateStorageSettingsRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

/** Platform-operator endpoints — gated on `platform.settings.*`, not a tenant resource. */
export const platformApi = {
  getSmtpSettings(): Promise<SmtpSettingsResponse> {
    return apiRequest<SmtpSettingsResponse>('/platform/smtp-settings');
  },

  updateSmtpSettings(body: UpdateSmtpSettingsRequest): Promise<SmtpSettingsResponse> {
    return apiRequest<SmtpSettingsResponse>('/platform/smtp-settings', { method: 'PUT', body });
  },

  sendTestEmail(to: string): Promise<void> {
    return apiRequest<void>('/platform/smtp-settings/test', { method: 'POST', body: { to } });
  },

  getOAuthProviderCredentials(): Promise<readonly OAuthProviderCredentialsSummary[]> {
    return apiRequest<readonly OAuthProviderCredentialsSummary[]>('/platform/oauth-providers');
  },

  updateOAuthProviderCredentials(
    provider: OAuthProviderSlug,
    body: UpdateOAuthProviderCredentialsRequest,
  ): Promise<OAuthProviderCredentialsSummary> {
    return apiRequest<OAuthProviderCredentialsSummary>(`/platform/oauth-providers/${provider}`, {
      method: 'PUT',
      body,
    });
  },

  getStorageSettings(): Promise<StorageSettingsResponse> {
    return apiRequest<StorageSettingsResponse>('/platform/storage-settings');
  },

  updateStorageSettings(body: UpdateStorageSettingsRequest): Promise<StorageSettingsResponse> {
    return apiRequest<StorageSettingsResponse>('/platform/storage-settings', {
      method: 'PUT',
      body,
    });
  },
};
